import React, { Component }  from 'react';
import {
  Collapse,
  Navbar,
  NavbarToggler,
  NavbarBrand,
  Nav,
  NavItem,
  NavLink,
} from 'reactstrap';
import FontAwesomeIcon from '@fortawesome/react-fontawesome'
import { faSignInAlt, faSignOutAlt, faShoppingCart, faCalendarAlt, faQuestionCircle, faMapMarker, faTv, faLock, faCamera } from '@fortawesome/free-solid-svg-icons'
import { connect } from 'react-redux';
import { updateUser } from '../actions/user-actions';


class Header extends Component {
  constructor(props) {
    super(props);

    this.toggle = this.toggle.bind(this);
    this.state = {
      isOpen: false,
      navHeight: 50
    };
  }
  toggle() {
    this.setState({
      isOpen: !this.state.isOpen
    });
  }
  render() {
      if (this.props.user)
      {
        console.log("user logged in:", this.props.user)
        return (
          <div style={{paddingTop: this.state.navHeight}}>
          <header className="Site-header">
            <Navbar color="info" light fixed="top" expand="md">
              <NavbarBrand href="/#/calendar">Beiseker Arena</NavbarBrand>
              <NavbarToggler onClick={this.toggle} />
              <Collapse isOpen={this.state.isOpen} navbar>
                <Nav className="ml-auto" navbar>
                  <NavItem>
                    <NavLink href="/#/calendar"><span><FontAwesomeIcon icon={faCalendarAlt} /></span> Schedule</NavLink>
                  </NavItem>
                  <NavItem>
                        <NavLink href="/#/contact"><span><FontAwesomeIcon icon={faMapMarker} /></span> Location</NavLink>
                  </NavItem>
                  <NavItem>
                        <NavLink href="/#/livebarn"><span><FontAwesomeIcon icon={faCamera} /></span> LiveBarn</NavLink>
                  </NavItem>
                  {false && this.props.user.roles &&
                  <NavItem>
                        <NavLink href="/#/cart"><span><FontAwesomeIcon icon={faShoppingCart} /></span> Cart ({this.props.cart && this.props.cart.length})</NavLink>
                  </NavItem>
                  }
                  {this.props.user.roles && this.props.user.roles.indexOf('Room Admin') > 0 &&
                  <NavItem>
                        <NavLink href="/#/admin/rooms"><span><FontAwesomeIcon icon={faTv} /></span> Arena Display</NavLink>
                  </NavItem>
                  }
                  {this.props.user.roles && this.props.user.roles.indexOf('Admin') > 0 &&
                  <NavItem>
                        <NavLink href="/#/admin"><span><FontAwesomeIcon icon={faLock} /></span> Admin</NavLink>
                  </NavItem>
                  }
                  <NavItem>
                        <NavLink href="/#/about"><span><FontAwesomeIcon icon={faQuestionCircle} /></span> Questions</NavLink>
                  </NavItem>

                  <NavItem>
                    <NavLink href="/#/logout"><span><FontAwesomeIcon icon={faSignOutAlt} /></span> Logout</NavLink>
                  </NavItem>
                </Nav>
              </Collapse>
            </Navbar>
          </header>
          </div>
        );
      } else {
        console.log("user not logged in")
        return (
          <div style={{paddingTop: this.state.navHeight}}>
          <header className="Site-header">
            <Navbar color="info" light fixed="top" expand="md">
              <NavbarBrand href="/#/calendar">Beiseker Arena</NavbarBrand>
              <NavbarToggler onClick={this.toggle} />
              <Collapse isOpen={this.state.isOpen} navbar>
                <Nav className="ml-auto" navbar>
                  <NavItem>
                    <NavLink href="/#/calendar"><span><FontAwesomeIcon icon={faCalendarAlt} /></span> Schedule</NavLink>
                  </NavItem>
                  <NavItem>
                        <NavLink href="/#/contact"><span><FontAwesomeIcon icon={faMapMarker} /></span> Location</NavLink>
                  </NavItem>
                  <NavItem>
                        <NavLink href="/#/livebarn"><span><FontAwesomeIcon icon={faCamera} /></span> LiveBarn</NavLink>
                  </NavItem>
                  <NavItem>
                        <NavLink href="/#/about"><span><FontAwesomeIcon icon={faQuestionCircle} /></span> Questions</NavLink>
                  </NavItem>


                  <NavItem>
                    <NavLink href="/#/login"><span><FontAwesomeIcon icon={faSignInAlt} /></span> Login</NavLink>
                  </NavItem>
                </Nav>
              </Collapse>
            </Navbar>
          </header>
          </div>
        );
      }
  }
}

const mapStateToProps = state => ({
  cart: state.cart,
  user: state.user
});

const connectedHeaderPage = connect(mapStateToProps)(Header);
export { connectedHeaderPage as Header };


// WEBPACK FOOTER //
// ./src/components/Header.jsx